module.exports = __webpack_public_path__ + "img/32.d04ba1c7.png";